import CEP from "../assets/footerCompanies/CEPN.svg";
import ISO from "../assets/footerCompanies/ISO.png";
import CCS from "../assets/footerCompanies/CCS.svg";

function FooterCertificates() {
  const footerCertificateLogos = [
    {
      logo: CEP,
      label: "Cyber Essentials Plus",
    },
    {
      logo: ISO,
      label: "International Security Organisation",
    },
    {
      logo: CCS,
      label: "Crown Commercial Service Supplier",
    },
  ];

  return (
    <div className="footer-certificate-container">
      {footerCertificateLogos.map((logo, index) => (
        <img
          key={index}
          className="footer-certificate-logo"
          src={logo.logo}
          alt={logo.label}
        />
      ))}
    </div>
  );
}

export default FooterCertificates;
